
import BlogHero from './components/BlogHero';
import FeaturedPost from './components/FeaturedPost';
import BlogGrid from './components/BlogGrid';
import BlogCategories from './components/BlogCategories';

export default function Blog() {
  return (
    <div>
      <BlogHero />
      <FeaturedPost />
      <BlogCategories />
      <BlogGrid />
    </div>
  );
}
